import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3057KontrolleStatus: 'idle',
    startProcess3057KontrolleError: undefined as any,
    loadUserParamsProcess3057KontrolleStatus: 'idle',
    loadUserParamsProcess3057KontrolleError: undefined as any,

    process3057KontrolleList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3057Kontrolle = createAsyncThunk('process3057KontrolleSlice/startProcess3057Kontrolle', async ({ process3057Kontrolle }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3057Kontrolle/`,
        prepareData(process3057Kontrolle),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3057KontrolleStatus } = getState().process3057KontrolleSlice
        return startProcess3057KontrolleStatus !== 'pending'
    }
})

export const loadUserParamsProcess3057Kontrolle = createAsyncThunk('process3057KontrolleSlice/loadUserParamsProcess3057Kontrolle', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3057Kontrolle/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3057KontrolleStatus } = getState().process3057KontrolleSlice
        return loadUserParamsProcess3057KontrolleStatus !== 'pending'
    }
})

const Process3057KontrolleSlice = createSlice({
    name: 'process3057KontrolleSlice',
    initialState,
    reducers: {
        resetstartProcess3057Kontrolle: (state) => {
            state.job = undefined
            state.startProcess3057KontrolleError = undefined
        },
        resetstartProcess3057KontrolleError: (state) => {
            state.startProcess3057KontrolleError = undefined
        },
        resetloadUserParamsProcess3057Kontrolle: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3057KontrolleError = undefined
        },
        resetloadUserParamsProcess3057KontrolleError: (state) => {
            state.loadUserParamsProcess3057KontrolleError = undefined
        },
        removeFromProcess3057KontrolleListById: (state, action) => {
            state.process3057KontrolleList = state.process3057KontrolleList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3057KontrolleListByIds: (state, action) => {
            state.process3057KontrolleList = state.process3057KontrolleList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3057KontrolleList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3057KontrolleStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3057KontrolleList = []
            state.startProcess3057KontrolleStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3057Kontrolle.pending, (state) => {
            state.startProcess3057KontrolleStatus = 'pending'
            state.startProcess3057KontrolleError = undefined
        })
        builder.addCase(startProcess3057Kontrolle.fulfilled, (state, action) => {
            state.startProcess3057KontrolleStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3057Kontrolle.rejected, (state, action) => {
            state.startProcess3057KontrolleStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3057KontrolleError = action.error.message
            } else {
                state.startProcess3057KontrolleError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3057Kontrolle.pending, (state) => {
            state.loadUserParamsProcess3057KontrolleStatus = 'pending'
            state.loadUserParamsProcess3057KontrolleError = undefined
        })
        builder.addCase(loadUserParamsProcess3057Kontrolle.fulfilled, (state, action) => {
            state.loadUserParamsProcess3057KontrolleStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3057Kontrolle.rejected, (state, action) => {
            state.loadUserParamsProcess3057KontrolleStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3057KontrolleError = action.error.message
            } else {
                state.loadUserParamsProcess3057KontrolleError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3057Kontrolle,
    resetstartProcess3057KontrolleError,
    resetloadUserParamsProcess3057Kontrolle,
    resetloadUserParamsProcess3057KontrolleError,
    removeFromProcess3057KontrolleListById,
    removeFromProcess3057KontrolleListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3057KontrolleSlice.actions
export default Process3057KontrolleSlice.reducer
